/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Acrobat_TypeInputs */

const en_pc_alt_t_acrobat_type = /** @type {(inputs: Pc_Alt_T_Acrobat_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commercial PDF suite`)
};

const zh_pc_alt_t_acrobat_type = /** @type {(inputs: Pc_Alt_T_Acrobat_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商业 PDF 套件`)
};

/**
* | output |
* | --- |
* | "Commercial PDF suite" |
*
* @param {Pc_Alt_T_Acrobat_TypeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_acrobat_type = /** @type {((inputs?: Pc_Alt_T_Acrobat_TypeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Acrobat_TypeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_acrobat_type(inputs)
	return zh_pc_alt_t_acrobat_type(inputs)
});
export { pc_alt_t_acrobat_type as "pc.alt.t.acrobat.type" }